import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ colors, spacing }) => ({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: spacing(4),
    maxWidth: "80%",
    marginHorizontal: "auto",
    _web: {
      minHeight: "90svh",
    },
  },
  icon: {
    width: spacing(16),
    height: spacing(16),
    color: colors.foregroundDefault,
  },
  title: {
    marginTop: spacing(4),
    marginBottom: spacing(2),
    textAlign: "center",
  },
  subtitle: {
    color: colors.foregroundDefault,
    textAlign: "center",
  },
  cta: {
    marginTop: spacing(14),
  },
}));

export default stylesheet;
